<script>
    import Textfield, {Input, Textarea} from '@smui/textfield';
    import List, {Item, Text, Graphic} from '@smui/list';
    import ViewColumn from '../common/multi-card-page/ViewColumn.svelte'
    import ModifyColumn from '../common/multi-card-page/ModifyColumn.svelte'
    import SaveButton from '../common/save-button/SaveButton.svelte'
    import {organizationList, currentOrganization, organizationStore} from './organizations'
    import {organizationsValidation, organizationsSaveState, organizationsPageState} from './organizationsState'
    import {userStore} from "../users/users";
    import ConfirmDialog from "../common/confirm/ConfirmDialog.svelte";
    import {get} from 'svelte/store'
    import WarningDialog from "./WarningDialog.svelte";
    import NextButton from "../common/next-button/NextButton.svelte";
    import SaveWindow from "../common/save-window/SaveWindow.svelte";

    let selectOrganizationCallback, confirmDialog, warningDialog;

    function deleteOrShowError() {
        let organization = get(currentOrganization)
        if (get(userStore).some(user => user.organizations.some(org => org === organization.companyId))) {
            warningDialog.open()
        } else {
            organizationList.deleteSelected()
            let organizations = $organizationStore
            organizations.forEach(element => {
                if (element.companyId > organization.companyId) {
                    element.companyId = element.companyId - 1
                }
            })
            organizationStore.set(organizations)
            resetDirtyState(false);
        }
    }

    function openDialog(organization) {
        if (organizationList.selectedWasUpdated()) {
            selectOrganizationCallback = () => organizationList.select(organization);
            confirmDialog.open()
        } else {
            organizationList.select(organization)
        }
    }

    let organizationNameDirty = false;
    let kvkNumberDirty = false;
    let streetDirty = false;
    let streetNumberDirty = false;
    let postCodeDirty = false;
    let cityDirty = false;
    let countryDirty = false;
    let branchDirty = false;
    let firstElement

    function addNewOrganization() {
        organizationList.resetSelected()
        resetDirtyState(false);
    }

    function saveSelected() {
        firstElement.focus()
        if ($organizationsSaveState) {
            organizationList.upsertSelected()
            resetDirtyState(false);
        } else {
            resetDirtyState(true);
        }
    }

    function resetDirtyState(value) {
        organizationNameDirty = value;
        kvkNumberDirty = value;
        streetDirty = value;
        streetNumberDirty = value;
        postCodeDirty = value;
        cityDirty = value;
        countryDirty = value;
        branchDirty = value;
    }

</script>
<SaveWindow saveFunction={saveSelected}/>
<div class="container-fluid mb-3">
    <div class="row justify-content-center">
        <ViewColumn header="KvK-nummers" on:new={addNewOrganization}>
            <ConfirmDialog on:confirm={selectOrganizationCallback} bind:this={confirmDialog}/>
            <WarningDialog bind:this={warningDialog}/>
            <List>
                {#each $organizationStore as organization}
                    <Item on:SMUI:action={() => openDialog(organization)}>
                        <div class="my-own-grid">
                            <span>{organization.name}</span>
                            <span>#{organization.companyId}</span>
                            <span>{organization.kvk}</span>
                        </div>
                    </Item>
                {/each}
            </List>
        </ViewColumn>
        <ModifyColumn header={$currentOrganization.id === "" ? "Nieuw KvK-nummer aanmelden" :"KvK-nummer bewerken"}
                      on:delete={deleteOrShowError} bind:editing={$currentOrganization.id}>
            <div class="container-fluid">
                {#if $currentOrganization.companyId === 1}
                    <div class="row mb-3 mt-2">
                        <div class="col-12 cng-alert-success p-3 mb-4">
                            Vul hier de gegevens van de hoofdvestiging in.
                        </div>
                    </div>
                {/if}
                <div class="row mb-3 mt-2">
                    <div class="col-12 col-lg-6">
                        <div>
                            <Textfield variant="outlined"
                                       bind:dirty={organizationNameDirty}
                                       invalid={organizationNameDirty && !$organizationsValidation.nameResult.valid}
                                       bind:value={$currentOrganization.name}
                                       bind:this={firstElement}
                                       label="Naam bedrijf*"/>
                        </div>
                        <div class="mt-4">
                            <Textfield variant="outlined"
                                       invalid={kvkNumberDirty && !$organizationsValidation.kvkResult.valid}
                                       bind:dirty={kvkNumberDirty}
                                       bind:value={$currentOrganization.kvk}
                                       label="KvK-nummer*"/>
                        </div>
                        <div class="mt-4">
                            <Textfield variant="outlined"
                                       bind:value={$currentOrganization.branch}
                                       invalid={branchDirty && !$organizationsValidation.branchResult.valid}
                                       bind:dirty={branchDirty}
                                       label="Vestigingsnummer"/>
                        </div>
                        <div class="errorbox arrow-top">
                            <p>
                                <b>Let op:</b> Hoofdvestiging wordt altijd zonder vestigingsnummer geregistreerd.
                                <br>
                                <br>
                                Het is mogelijk om een vestigingsnummer op te geven echter raden we dit sterk af.
                                Vanwege juridische redenen staan belangrijke dienstverleners (Bijvoorbeeld: UWV,
                                belastingdienst en Douane) het niet toe om in te loggen wanneer een eHerkenningsmiddel
                                is geregistreerd met een vestigingsnummer.
                                <br>
                                <br>
                                Mocht u alsnog een vestigingsnummer willen registreren raden wij aan om naast de
                                aanmelding met vestigingsnummer ook een registratie te doen met enkel het KvK-nummer.
                            </p>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6 mt-4 mt-lg-0">
                        <div>
                            <Textfield variant="outlined"
                                       disabled
                                       bind:value={$currentOrganization.companyId}
                                       label="Volgnummer"/>
                        </div>
                        <div class="mt-4">
                            <Textfield variant="outlined"
                                       invalid={streetDirty && !$organizationsValidation.streetResult.valid}
                                       bind:dirty={streetDirty}
                                       bind:value={$currentOrganization.street}
                                       label="Straatnaam*"/>
                        </div>
                        <div class="mt-4">
                            <Textfield variant="outlined"
                                       invalid={streetNumberDirty && !$organizationsValidation.numberResult.valid}
                                       bind:dirty={streetNumberDirty}
                                       bind:value={$currentOrganization.number}
                                       label="Huisnummer*"/>
                        </div>
                        <div class="mt-4">
                            <Textfield variant="outlined"
                                       invalid={postCodeDirty && !$organizationsValidation.postCodeResult.valid}
                                       bind:dirty={postCodeDirty}
                                       bind:value={$currentOrganization.postCode}
                                       label="Postcode*"/>
                        </div>
                        <div class="mt-4">
                            <Textfield variant="outlined"
                                       invalid={cityDirty && !$organizationsValidation.cityResult.valid}
                                       bind:dirty={cityDirty}
                                       bind:value={$currentOrganization.city}
                                       label="Stad*"/>
                        </div>
                        <div class="mt-4">
                            <Textfield disabled variant="outlined"
                                       invalid={countryDirty && !$organizationsValidation.countryResult.valid}
                                       bind:dirty={countryDirty}
                                       bind:value={$currentOrganization.country}
                                       label="Land"/>
                        </div>
                    </div>
                </div>
                <SaveButton on:save={saveSelected}/>
                <NextButton navigationLink="#/users" canContinue={$organizationsPageState}/>
            </div>
        </ModifyColumn>
    </div>
</div>
<style>
    .my-own-grid{
        display: grid;
        grid-template-columns: 5fr 1fr 3fr;
        grid-column-gap: .5rem;
        flex: 1;
        font-weight: bold;
    }
</style>
